import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '/', component: (resolve) => {
      require.ensure(['../views/Dashboard/Index.vue'], () => {
        resolve(require('../views/Dashboard/Index.vue'))
      })
  },  meta: { requiresAuth: false } }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js